import InterislandRateViewPage from '../containers/Rate/Interisland/View/InterislandRateView'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers' 
 
const ExpressRateView = () => { 

    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <InterislandRateViewPage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default ExpressRateView
